import { render, staticRenderFns } from "./cxList.vue?vue&type=template&id=46e56752&scoped=true"
import script from "./cxList.vue?vue&type=script&lang=js"
export * from "./cxList.vue?vue&type=script&lang=js"
import style0 from "./cxList.vue?vue&type=style&index=0&id=46e56752&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46e56752",
  null
  
)

export default component.exports